module.exports = __webpack_public_path__ + "media/images/computer-p-2000-4941b65ec2484db19c220f926bcac26b.jpeg";